module.exports = __webpack_public_path__ + "static/media/pen-an-paper-icon.25a93d7e.svg";